import { render, staticRenderFns } from "./BindsList.vue?vue&type=template&id=9eff356e&scoped=true"
import script from "./BindsList.vue?vue&type=script&lang=js"
export * from "./BindsList.vue?vue&type=script&lang=js"
import style0 from "@/components/regras/regra-modal.css?vue&type=style&index=0&id=9eff356e&prod&scoped=true&lang=css&external"
import style1 from "./BindsList.vue?vue&type=style&index=1&id=9eff356e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eff356e",
  null
  
)

export default component.exports